import serializeAction from './base';

function normalizePrice(price) {
  return price / 100;
}

function serializeOffer(offer) {
  if (!offer?.product) return {};
  const { product } = offer;
  return {
    primaryCategory: product.family.primaryCategory,
    familyName: product.family.name,
    name: product.name,
    articleNumber: product.articleNumber,
    eans: [],
    quantity: 1,
    price: normalizePrice(offer.prices[0].amount),
  };
}

export default function serializeOffers(action, offers) {
  const items = (offers || []).map(serializeOffer);
  return serializeAction({
    action,
    items,
    customerIdentified: false,
  });
}
